"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _OwnerRecord = _interopRequireDefault(require("customer-data-objects/owners/OwnerRecord"));

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchOwnersActionTypes.SUCCESS, function (state, action) {
  return action.payload.data.reduce(function (ownersById, owner) {
    return ownersById.set(owner.ownerId, _OwnerRecord.default.fromJS(owner));
  }, state);
}), initialState);

exports.default = _default;
module.exports = exports.default;